/**
 * 余额缓存 (SWR 模式: 先展示旧值, 再拉真实数据更新)
 *
 * 缓存按 (userId, currency) 隔离, 多账号/多币种互不干扰.
 * 缓存的是已格式化的字符串 (与 UI 一致, 命中后无需再格式化).
 */

import { getCached, setCached } from './useUserCache'

const PREFIX = 'balance:'

export function getCachedBalance(currency: string): string | undefined {
  if (!currency) return undefined
  return getCached<string>(`${PREFIX}${currency}`)
}

export function setCachedBalance(currency: string, value: string): void {
  if (!currency) return
  setCached(`${PREFIX}${currency}`, value)
}
